<template>
  <a-form :form="form" @submit.prevent="handleConfigInfoSubmit">
    <a-row class="content-panle margin-0 padding-tb-0" :gutter="30">

      <!-- 陌生人预警 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.warning.strangerWarningTitle')}}</h3>
        <!-- 是否启用陌生人预警 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.strangerWarning')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['strangerWarning',{ initialValue: deviceConfig.strangerWarning || '2' }]"
              @change='val => isOpenStrangerWarning = val === "1"'
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用陌生人预警提示闪烁 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.strangerWarningFlash')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenStrangerWarning"
              v-decorator="['strangerWarningFlash',{ initialValue: deviceConfig.strangerWarningFlash || '2' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用陌生人预警提示声音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.strangerWarningVoice')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenStrangerWarning"
              v-decorator="['strangerWarningVoice',{ initialValue: deviceConfig.strangerWarningVoice || '2' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-col>

       <!-- 黑名单预警 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.warning.blacklistWarningTitle')}}</h3>
        <!-- 是否启用陌生人预警 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.blacklistWarning')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['blacklistWarning',{ initialValue: deviceConfig.blacklistWarning || '1' }]"
              @change='val => isOpenBlacklistWarning = val === "1"'
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用黑名单预警提示闪烁 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.blacklistWarningFlash')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenBlacklistWarning"
              v-decorator="['blacklistWarningFlash',{ initialValue: deviceConfig.blacklistWarningFlash || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用陌生人预警 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.blacklistWarningVoice')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenBlacklistWarning"
              v-decorator="['blacklistWarningVoice',{ initialValue: deviceConfig.blacklistWarningVoice || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-col>

      <!-- 人体测温报警 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.warning.temperatureAlarmTitle')}}</h3>
        <!-- 是否启用体温异常报警 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.temperatureAlarm')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['temperatureAlarm',{ initialValue: deviceConfig.temperatureAlarm || '1' }]"
              @change='val => isOpentemperatureAlarm = val === "1"'
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用体温异常报警提示闪烁 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.temperatureAlarmFlash')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpentemperatureAlarm"
              v-decorator="['temperatureAlarmFlash',{ initialValue: deviceConfig.temperatureAlarmFlash || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用体温异常报警提示声音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.temperatureAlarmVoice')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpentemperatureAlarm"
              v-decorator="['temperatureAlarmVoice',{ initialValue: deviceConfig.temperatureAlarmVoice || '2' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-col>

      <!-- 设备异常报警 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.warning.deviceAbnormalAlarmTitle')}}</h3>
        
        <!-- 是否启用网络异常报警 -->
        <!-- <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.networkAbnormalAlarm')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['networkAbnormalAlarm',{ initialValue: deviceConfig.networkAbnormalAlarm || '1' }]"
              @change='val => isOpenNetworkAbnormalAlarm = val === "1"'
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
        <!-- 是否启用网络异常报警提示闪烁 -->
        <!-- <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.networkAbnormalAlarmFlash')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenNetworkAbnormalAlarm"
              v-decorator="['networkAbnormalAlarmFlash',{ initialValue: deviceConfig.networkAbnormalAlarmFlash || '2' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
        <!-- 是否启用网络异常报警提示声音 -->
        <!-- <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.networkAbnormalAlarmVoice')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenNetworkAbnormalAlarm"
              v-decorator="['networkAbnormalAlarmVoice',{ initialValue: deviceConfig.networkAbnormalAlarmVoice || '2' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->

        <!-- 是否启用状态异常报警 -->
        <!-- <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.abnormalStateAlarm')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['abnormalStateAlarm',{ initialValue: deviceConfig.abnormalStateAlarm || '1' }]"
              @change='val => isOpenAbnormalStateAlarm = val === "1"'
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
        <!-- 是否启用状态异常报警提示闪烁 -->
        <!-- <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.abnormalStateAlarmFlash')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenAbnormalStateAlarm"
              v-decorator="['abnormalStateAlarmFlash',{ initialValue: deviceConfig.abnormalStateAlarmFlash || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
        <!-- 是否启用状态异常报警提示声音 -->
        <!-- <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.abnormalStateAlarmVoice')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenAbnormalStateAlarm"
              v-decorator="['abnormalStateAlarmVoice',{ initialValue: deviceConfig.abnormalStateAlarmVoice || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->

        <!-- 是否启用自检异常报警 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.selfCheckAbnormalAlarm')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['selfCheckAbnormalAlarm',{ initialValue: deviceConfig.selfCheckAbnormalAlarm || '1' }]"
              @change='val => isOpenSelfCheckAbnormalAlarm = val === "1"'
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用自检异常报警提示闪烁 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.selfCheckAbnormalAlarmFlash')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenSelfCheckAbnormalAlarm"
              v-decorator="['selfCheckAbnormalAlarmFlash',{ initialValue: deviceConfig.selfCheckAbnormalAlarmFlash || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用自检异常报警提示声音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.warning.selfCheckAbnormalAlarmVoice')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenSelfCheckAbnormalAlarm"
              v-decorator="['selfCheckAbnormalAlarmVoice',{ initialValue: deviceConfig.selfCheckAbnormalAlarmVoice || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.warning.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.warning.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-col>

      <a-col :span="24" style="margin-top: 16px; text-align: right">
        <a-button 
          type="primary" 
          html-type="submit" 
          :loading="submitting"
        >{{$t('devicesManaConfig.warning.submitBtn')}}</a-button>
        <a-button 
          :style="{ marginLeft: '8px' }"
          @click="$emit('backList')"
        >{{$t('devicesManaConfig.warning.backBtn')}}</a-button>
      </a-col>
    </a-row>
   
  </a-form>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {},
  props: {
    deviceConfig: {
      type: Object,
      required: true,
      default: null
    },
    deviceId: {
      type: String,
      required: true,
      default: undefined
    }
  },
  data() {
    return {
      lastDeviceId: null,

      form: this.$form.createForm(this),

      isOpenStrangerWarning: false, // 是否启用陌生人预警
      isOpenBlacklistWarning: true, // 是否启用黑名单预警
      isOpentemperatureAlarm: true, // 体温异常报警
      isOpenNetworkAbnormalAlarm: true, // 是否启用网络异常报警
      isOpenAbnormalStateAlarm: true, // 是否启用状态异常报警
      isOpenSelfCheckAbnormalAlarm: true, // 是否启用自检异常报警

      submitting: false
    }
  },
  created() {},
  activated() {
    if (this.deviceId !== this.lastDeviceId) {
      this.lastDeviceId = this.deviceId 
      this.initConfig()  
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  methods: {
    // 处理进入本类配置的数据
    initConfig() {
      this.$nextTick(() => {
        const { 
          strangerWarning, 
          blacklistWarning, 
          temperatureAlarm,
          networkAbnormalAlarm,
          abnormalStateAlarm,
          selfCheckAbnormalAlarm
        } = this.deviceConfig
        strangerWarning && (this.isOpenStrangerWarning = strangerWarning === '1')
        blacklistWarning && (this.isOpenBlacklistWarning = blacklistWarning === '1')
        temperatureAlarm && (this.isOpentemperatureAlarm = temperatureAlarm === '1')
        networkAbnormalAlarm && (this.isOpenNetworkAbnormalAlarm = networkAbnormalAlarm === '1')
        abnormalStateAlarm && (this.isOpenAbnormalStateAlarm = abnormalStateAlarm === '1')
        selfCheckAbnormalAlarm && (this.isOpenSelfCheckAbnormalAlarm = selfCheckAbnormalAlarm === '1')
      });  
    },
    // 提交配置信息
    handleConfigInfoSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submitConfig', values)
        }
      })
    }
  }    
}
</script>

<style scoped>
</style>